// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\components\\\\pages\\\\book-studio\\\\StudioHeroSection\\\\StudioHeroSection.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\components\\pages\\book-studio\\StudioHeroSection\\StudioHeroSection.tsx");
  import.meta.hot.lastModified = "1757171103291.8179";
}
// REMIX HMR END

import { PhotoGallery } from "~/components/shared/PhotoGallery";
import { Tag } from "~/components/shared/Tag";
import { LocationIcon } from "~/components/pages/locations/PlanYourVisitSection/components/LocationIcon";
export function StudioHeroSection({
  data
}) {
  return <PhotoGallery images={data.images} />;
}
_c = StudioHeroSection;
export function StudioInfoSection({
  data
}) {
  return <div className="space-y-6">
      {/* Tags */}
      <div className="flex flex-wrap gap-2">
        <Tag>NOMADIC SATELLITE</Tag>
        <Tag>{data.studioType}</Tag>
        <Tag>
          {data.location.toUpperCase()}, {data.country}
        </Tag>
      </div>

      {/* Title */}
      <h1 className="text-stat-number font-bold text-gray-900 leading-tight">
        PROFESSIONAL {data.studioType} FOR CREATIVES
      </h1>

      {/* Address */}
      <div className="flex items-start space-x-2 text-gray-600">
        <LocationIcon />
        <p className="text-sm">{data.address}</p>
      </div>

      {/* Description */}
      <p className="text-gray-700 leading-relaxed">
        {data.description}
      </p>
    </div>;
}
_c2 = StudioInfoSection;
var _c, _c2;
$RefreshReg$(_c, "StudioHeroSection");
$RefreshReg$(_c2, "StudioInfoSection");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;